export default __webpack_public_path__ + "static/loading-animation-f82e41edcb071b23dd333a2c06ba0d9b.gif";